// extracted by mini-css-extract-plugin
export default {"iconWrapper":"RLFilterIcon_iconWrapper__dtTE-","icon":"RLFilterIcon_icon__SHzWL","activeDot":"RLFilterIcon_activeDot__UR+CQ"};